<div mat-dialog-content>
    <div class="fill_scroll">
        <div class="row">
            <br/>
            <div class="input-group">
                <mat-form-field class="form-element">
                    <mat-label>{{'general.name' | transloco}}</mat-label>
                    <input matInput type="text" class="form-control" inputrestriction="basic2"
                           placeholder="{{'general.name' | transloco}}" [(ngModel)]="name" autocomplete="off"/>
                </mat-form-field>
            </div>
        </div>
    </div>
    <br/>
    <div mat-dialog-actions style="justify-content: center;">
        <button mat-button color="warn" (click)="onNoClick()" style="position: relative;right: 15px;">
            {{'general.cancel' | transloco}}
        </button>
        <!--  <button mat-stroked-button color="primary" [disabled]="!(data.Name || data.Description)" [mat-dialog-close]="{nodeName: data.Name, nodeDescription: data.Description}" style="position: relative;left: 20px;">-->
        <button mat-button (click)="onAdd()">
            {{data.Component}}
        </button>
    </div>
    <br/>
    <br/>
</div>


